import { NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, signal } from '@angular/core';
import { IconComponent } from '../../../../../icon/icon.component';
import { SanitizeUrlPipe } from '../../../../pipes/sanitize-url.pipe';

@Component({
    selector: 'nw-video',
    templateUrl: './video.component.html',
    styleUrls: ['./video.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [IconComponent, SanitizeUrlPipe, NgOptimizedImage]
})
export class VideoComponent {
    @Input() videoUrl?: string;
    @Input() thumbnail?: string;
    @Input() duration?: string;
    @Input() altText?: string;
    @Input() title?: string;

    public isVideoPlaying = signal(false);
    public playbackUrl = signal<string | undefined>(undefined);

    public id: string = this.generateUniqueId();

    // The accessible name has to contain the button's visible text (the duration), or
    // speech-input users can't activate it by saying what they see (WCAG 2.5.3).
    public get playLabel(): string {
        const LABEL = this.title ? `Play video: ${this.title}` : 'Play video';
        return this.duration ? `${LABEL} (${this.duration})` : LABEL;
    }

    public onVideoClick(): void {
        this.isVideoPlaying.set(true);
        this.playbackUrl.set(this.withAutoplay(this.videoUrl));
    }

    private withAutoplay(url?: string): string | undefined {
        if (!url || url.includes('autoplay=')) return url;

        const SEPARATOR = url.includes('?') ? '&' : '?';
        return `${url}${SEPARATOR}autoplay=1&playsinline=1`;
    }

    private generateUniqueId(length = 10): string {
        const CHARS = 'abcdefghijklmnopqrstuvwxyz';
        let result = '';
        for (let i = 0; i < length; i++) {
            result += CHARS.charAt(Math.floor(Math.random() * CHARS.length));
        }
        return result;
    }
}
